import { NOT_SET, track } from '@/src/utils/tracking';
import { logError } from '@/src/logger';

const productImpressionsLoaded = (
  bannerId,
  businessType,
  position,
  productName,
  productSku,
  shopId,
  rankingRequestId,
) => {
  const EVENT_NAME = 'product_impressions.loaded';

  try {
    const payload = {
      bannerId: bannerId || NOT_SET,
      businessType,
      categoryId: NOT_SET,
      impressionsListName: 'section',
      productIndex: position,
      productName,
      productSearched: NOT_SET,
      productSku: productSku || NOT_SET,
      screenType: 'items_landing_qc',
      screenName: 'campaign_landing',
      searchRequestId: NOT_SET,
      shopId,
      shopType: businessType,
      subCategoryId: NOT_SET,
      vendorSponsoring: 'False',
      vendorSponsoringPlacement: 'section_details:swimlane',
      rankingRequestId,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default productImpressionsLoaded;
